<div class="error-page">
  <div class="error-page-content">
    <div class="info">
      <h1>404</h1>
    </div>
  </div>
</div>
